<template>
  <div class="type-group">
    <div
      v-for="item in options"
      :key="item.type"
      @click="$emit('input', item.type)"
    >
      <div>
        <img
          v-show="item.type === value"
          :src="require(`../../../../assets/images/${item.iconActiveName}.png`)"
          alt=""
        />
        <img
          v-show="item.type !== value"
          :src="require(`../../../../assets/images/${item.iconName}.png`)"
          alt=""
        />
      </div>
      <p>{{ item.title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      require: true
    },
    value: {
      type: String,
      require: true
    }
  }
};
</script>

<style lang="less" scoped>
.type-group {
  display: flex;
  flex-wrap: wrap;
  > div:not(:last-child) {
    margin-right: 50px;
  }
  > div {
    cursor: pointer;
    > div {
      width: 54px;
      height: 54px;
      > img {
        width: 100%;
        height: auto;
      }
    }
    > p {
      font-size: 12px;
      color: #333333;
      margin-top: 10px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/PictureAdvertising/components/TypeGroup.vue